import { UpsertGroupMappingStep } from './upsertGroupMappingStep';

import type { Step } from '../wizard/Step';

export interface UpsertGroupMappingState {
  editMode: boolean;
  idpId: string;
  providerGroupId: string;
  roleIds: string[];
  groupId?: string;
}

export const upsertGroupMappingFlow: Step<UpsertGroupMappingState> = {
  id: 'upsert_group_mapping',
  Component: UpsertGroupMappingStep,
};
